import {
  CreateTriggerPdfGenerationKitEntity,
  TriggerPdfGenerationKitEntity,
} from '@/pages/privatePages/trigger-pdf-generation-kit/types';
import { BaseService } from './base.service';

class TriggerPdfGenerationKitServiceClass extends BaseService<
  'triggerPdfGenerationKit',
  TriggerPdfGenerationKitEntity,
  CreateTriggerPdfGenerationKitEntity
> {
  constructor() {
    super('trigger-pdf-generation-kit');
  }
}
export const triggerPdfGenerationKitService =
  new TriggerPdfGenerationKitServiceClass();
